import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Skeleton } from '@/components/ui';

/** One number on the dashboard, linking to the page that owns it. `null` while it loads. */
export function Metric({
  icon: Icon,
  label,
  value,
  tone,
  to,
}: {
  readonly icon: LucideIcon;
  readonly label: string;
  readonly value: string | null;
  readonly tone?: string;
  readonly to: string;
}): ReactNode {
  return (
    <Link to={to} className="card metric-card">
      <div className="card-body">
        <p className="metric-label">
          <Icon size={14} aria-hidden="true" />
          {label}
        </p>
        <p className={`metric-value ${tone ?? ''}`}>
          {value ?? <Skeleton width={48} height={26} radius="sm" />}
        </p>
      </div>
    </Link>
  );
}
